<template>
  <section class="about-us-section position-relative see__pad">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="about-content">
            <div class="about-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="about-main-title">
              <h2>{{ content.mainTitle }}</h2>
            </div>
            <div class="about-description">
              <p>{{ content.description }}</p>
            </div>
            <div class="about-cta-wrapper">
              <router-link :to="content.ctaLink" class="theme-btn theme-btn-one">
                <i class="icon-02"></i> {{ content.ctaText }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="stats-grid">
            <div 
              v-for="(stat, index) in content.stats" 
              :key="index"
              class="stat-card"
              :class="`stat-${index + 1}`"
              :data-wow-delay="`0.${index + 1}s`"
            >
              <div class="stat-number" :data-count="stat.number">0</div>
              <div class="stat-label">{{ stat.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeItsAboutUsComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "About Us",
        mainTitle: "Who we are",
        description: "Sogdo is a group of passionate technology professionals, delivering customer-centric solutions for over two decades. We believe in achieving organizational scalability with innovation, workflow optimization, and digital transformation. Technology at our core and customers in our hearts.",
        ctaText: "Learn More",
        ctaLink: "/about",
        stats: [
          {
            number: 15,
            label: "YEARS OF EXPERIENCE"
          },
          {
            number: 500,
            label: "GLOBAL WORKFORCE"
          },
          {
            number: 1000,
            label: "PROJECT DELIVERED"
          },
          {
            number: 25,
            label: "INNOVATION AWARDS"
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* About Us Section Styles */
.about-us-section {
  padding: 100px 0;
  background: #fff;
  position: relative;
}

.about-content {
  padding: 40px 0;
}

.about-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #C00A87;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.about-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #2c3e50;
  margin-bottom: 30px;
  font-family: 'Archivo', sans-serif;
}

.about-description p {
  font-size: 16px;
  line-height: 28px;
  color: #6c757d;
  margin-bottom: 40px;
  font-family: 'Open Sans', sans-serif;
}

.about-cta-wrapper {
  margin-top: 20px;
}

.theme-btn {
  display: inline-flex;
  align-items: center;
  padding: 15px 30px;
  background: #F6EC4F;
  color: #00061A;
  text-decoration: none;
  border-radius: 5px;
  font-family: 'Archivo', sans-serif;
  font-weight: 600;
  transition: all 0.3s ease;
  margin: 20px 0;
}

.theme-btn i {
  margin-right: 10px;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.theme-btn:hover i {
  transform: translateX(3px);
}

.theme-btn:hover {
  background: #e5d43f;
  color: #00061A;
  transform: translateY(-2px);
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  padding: 40px 0;
}

.stat-card {
  background: #fff;
  border-radius: 15px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #F6EC4F, #FB0E76);
}

.stat-1::before {
  background: linear-gradient(90deg, #F6EC4F, #ffed4e);
}

.stat-2::before {
  background: linear-gradient(90deg, #C00A87, #87ceeb);
}

.stat-3::before {
  background: linear-gradient(90deg, #FB0E76, #ff69b4);
}

.stat-4::before {
  background: linear-gradient(90deg, #C00A87, #F6EC4F);
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
  line-height: 1;
}

.stat-label {
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: 'Open Sans', sans-serif;
}

/* Count-up Animation */
@keyframes countUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-number.animate {
  animation: countUp 0.6s ease-out;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .about-us-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .about-us-section {
    padding: 60px 0;
  }
  .about-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .stat-card {
    padding: 30px 20px;
  }

  .stat-number {
    font-size: 36px;
  }
}

@media only screen and (max-width: 399px) {
  .about-us-section {
    padding: 40px 0;
  }
  
  .about-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }

  .about-section-label h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }

  .stat-card {
    padding: 25px 20px;
  }

  .stat-number {
    font-size: 32px;
  }
}
</style>
